<template>
  <div
    class="user-avatar"
    :style="{ cursor: props.clickable ? 'pointer' : 'auto' }"
    @click="emit('click', $event)"
  >
    <img class="user-avatar__img" v-if="imagePath" :src="imagePath" alt="" />
    <template v-else>
      <div v-if="userInitials" class="user-avatar__initials">
        {{ userInitials }}
      </div>
      <div v-else class="user-avatar__placeholder">
        <ion-icon :icon="personOutline" />
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { UserI } from '@/types';
import { IonIcon } from '@ionic/vue';
import { personOutline } from 'ionicons/icons';
import { getFirebaseStorageResizedAvatar } from '@/services/methods';

const props = defineProps<{
  user?: Partial<UserI>;
  clickable?: boolean;
}>();

const emit = defineEmits(['click']);

const userInitials = computed(() =>
  props.user?.alias ? props.user.alias[0] + props.user.alias[1] : ''
);

const imagePath = computed(() => {
  if (!props.user?.avatarUrl) {
    return '';
  }
  return getFirebaseStorageResizedAvatar(props.user.avatarUrl, 'icon');
});
</script>

<style lang="scss" scoped>
.user-avatar {
  width: 40px;
  height: 40px;
  min-width: 40px;
  min-height: 40px;

  &__initials {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: #a9e3ce;
    color: #fff;
    font-weight: 600;
    font-size: 0.8rem;
    text-transform: uppercase;
  }

  &__placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ebedfb;
    color: #172659;
    border-radius: 100%;
    font-size: 1.2em;
  }

  &__img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
  }
}
</style>
